/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Replacement_WarningInputs */

const vi_einvoice_replacement_warning = /** @type {(inputs: Einvoice_Replacement_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là hóa đơn thay thế.`)
};

/**

* @param {Einvoice_Replacement_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_replacement_warning = /** @type {((inputs?: Einvoice_Replacement_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Replacement_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_replacement_warning(inputs)
});